<label class="control-label" *ngIf="(title && title.length > 0) || (secondaryTitle && secondaryTitle.length > 0)">
  <span class="form-label">
    {{ title }}
    <span *ngIf="secondaryTitle"> - </span>
    <small>{{ secondaryTitle }}</small>
  </span>
</label>

<div
  class="checkbox"
  *ngFor="let option of options; let i = index"
  [attr.data-qa]="option.testId"
  [ngClass]="{ required: (requiredReverse ? option.checked : !option.checked) && required && isTouched }"
>
  <input
    type="checkbox"
    name="option{{ option.id }}"
    id="option{{ option.id }}"
    [(ngModel)]="option.checked"
    (change)="onToggle()"
    [attr.disabled]="disabled || null"
    [ngClass]="{ disabled: disabled }"
  />
  <label for="option{{ option.id }}">{{ option.name }}</label>
</div>

<ng-content select="[rx-error]"></ng-content>

<div rx-error *ngIf="error" class="rx-error">{{ error }}</div>
